import { render } from "./FooterComponent.vue?vue&type=template&id=39086574&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "@/assets/css/footer.css?vue&type=style&index=0&id=39086574&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39086574"]])

export default __exports__